<template>
  <datetime
    @input="changed()"
    v-model="date"
    input-class="form-control"
    type="date"
    zone="utc"
    moment-locale="es"
    :phrases="{ok: 'Aceptar', cancel: 'Cancelar'}"
  ></datetime>
</template>

<script>
export default {
  props: {
    currentValue: null
  },
  data() {
    return {
      date: null
    };
  },
  methods: {
    changed() {
      this.$emit("input", this.date);
    }
  },
  watch: {
    currentValue: function(newValue, oldValue) {
      this.date = newValue;
      this.$emit("input", this.date);
    }
  }
};
</script>